import SimpleMdeReact from "react-simplemde-editor";
import { Card, CardBody, Col, Row } from "reactstrap";
import { MdeEditorExample } from "../../../../constants";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import { MdeEditorText } from "../../../../data/applications/LetterBox";

const MdeExampleOne = () => {

  return (
    <Row>
      <Col sm="12">
        <Card>
          <CommonCardHeader title={MdeEditorExample} />
          <CardBody>
            <SimpleMdeReact id="editor_container" placeholder={MdeEditorText} options={{ autofocus: true, spellChecker: false }} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default MdeExampleOne;
